__turbopack_context__.v({
  "avatar": "Avatar-module__ZYOtkq__avatar",
  "img": "Avatar-module__ZYOtkq__img",
  "t-dark": "Avatar-module__ZYOtkq__t-dark",
  "t-light": "Avatar-module__ZYOtkq__t-light",
});
